import script from "./PersonCalendarIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonCalendarIndex.vue?vue&type=script&setup=true&lang=js"

import "./PersonCalendarIndex.vue?vue&type=style&index=0&id=67ed9e3c&lang=css"
import "./PersonCalendarIndex.vue?vue&type=style&index=1&id=67ed9e3c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ed9e3c"]])

export default __exports__